import CurrencyValue from '@payaca/components/currencyValue/CurrencyValue';
import MarkdownCore from '@payaca/components/markdownLabel/MarkdownCore';
import { DragHandle } from '@payaca/dnd';
import { FC } from 'react';
import { EstimateLineItem } from '../types';

const remarkFirstBlock = () => (tree: { children: unknown[] }) => {
  tree.children = tree.children.slice(0, 1);
};

const rehypeClampFirstBlock =
  () =>
  (tree: {
    children: Array<{
      type: string;
      properties?: { className?: string[] | string };
    }>;
  }) => {
    const first = tree.children.find((c) => c.type === 'element');
    if (!first) return;
    first.properties = first.properties ?? {};
    const existing = first.properties.className;
    const existingArr = Array.isArray(existing)
      ? existing
      : typeof existing === 'string'
        ? [existing]
        : [];
    first.properties.className = [...existingArr, 'line-clamp-1'];
  };

type EstimateItemRowProps = {
  lineItem: EstimateLineItem;
  onClick: () => void;
};

const EstimateItemRow: FC<EstimateItemRowProps> = (props) => {
  const { lineItem, onClick } = props;
  const itemLabel = lineItem.internalReference || 'Untitled item';
  return (
    <div className="group flex items-center gap-4 hover:bg-gray-50 bg-white typography:prose p-3.5 w-full relative">
      <DragHandle
        className="pointer-events-auto z-20"
        as="button"
        label={itemLabel}
        id={lineItem.id}
      />

      <button
        type="button"
        className="flex items-center gap-4 text-left bg-white group-hover:bg-gray-50 stretched-link cursor-pointer flex-1"
        onClick={onClick}
        aria-label={`Edit/Delete: ${itemLabel}`}
      >
        <div className="flex-1">
          <h4>{lineItem.internalReference}</h4>

          <MarkdownCore
            markdown={lineItem.description ?? ''}
            remarkPlugins={[remarkFirstBlock]}
            rehypePlugins={[rehypeClampFirstBlock]}
          />
        </div>

        <div className="text-right">
          <p className="supporting-body text-gray-500">
            {lineItem.quantity} x{' '}
            <CurrencyValue {...lineItem.unitPriceExcTax} />
          </p>
          <p>
            <CurrencyValue {...lineItem.totalIncTax} />
          </p>
        </div>
      </button>
    </div>
  );
};

export default EstimateItemRow;
